import LazyPage from './components/controls/LazyPage';
import { requireAuth, requestData, Config } from './service';
import { getAsyncInjectors } from './utils/asyncInjectors';

/*eslint-disable*/
const errorLoading = (err) => {};

const loadParams = Config.loadParams();

const loadModule = (cb) => (componentModule) => {
  cb(null, componentModule.default);
};

export default function createRoutes(store) {
  const { injectSagas } = getAsyncInjectors(store);

  const renderComponent = (loadComponent) => {
    let savedComponent;
    return (nextState, cb) => {
      const renderRoute = loadModule(cb);
      if (savedComponent) {
        renderRoute(savedComponent);
      } else {
        loadComponent((loadedComponent) => {
          savedComponent = loadedComponent;
          renderRoute(savedComponent);
        });
      }
    };
  };

  const getChildRoutes = (appName) => {
    return loadParams[appName].pages.map(({ path, request, accessRules, loader }) => ({
      path,
      onEnter: requestData(store, request, accessRules, appName),
      component: LazyPage(loader)
    }));
  };

  return [
    {
      onEnter: requireAuth(store),
      getComponent: renderComponent((renderRoute) => {
        const importModules = Promise.all([
          import('./containers/PortalApp/sagas'),
          import('./containers/PortalApp')
        ]);
        importModules.then(([sagas, component]) => {
          injectSagas(sagas.default);
          renderRoute(component);
        });
      }),
      childRoutes: getChildRoutes('portalApp')
    },
    {
      getComponent: renderComponent((renderRoute) => {
        const importModules = Promise.all([
          import('./containers/OAuthApp/sagas'),
          import('./containers/OAuthApp')
        ]);
        importModules.then(([sagas, component]) => {
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      }),
      childRoutes: getChildRoutes('oAuthApp')
    },
    {
      getComponent: renderComponent((renderRoute) => {
        const importModules = Promise.all([
          import('./containers/LoginApp/sagas'),
          import('./containers/LoginApp')
        ]);
        importModules.then(([sagas, component]) => {
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      }),
      childRoutes: getChildRoutes('loginApp')
    }
  ];
}
